import { useAppNavigation } from '@euler/app/components/AppNavigationProvider';
import { useEffect } from 'react';

/**
 * A screen opened in place of the BI entry without a transition takes its
 * transitions back once shown: `animationEnabled` covers leaving the screen
 * too, and on iOS swipe-back with it.
 */
export function useAnimatedAfterInstant(instant: boolean | undefined) {
  const navigation = useAppNavigation();
  useEffect(() => {
    if (!instant) return;
    const frame = requestAnimationFrame(() =>
      navigation.setParams({ instant: undefined }),
    );
    return () => cancelAnimationFrame(frame);
  }, [instant, navigation]);
}
